import { render, staticRenderFns } from "./lotteryrecord.vue?vue&type=template&id=06863b15"
import script from "./lotteryrecord.vue?vue&type=script&lang=js"
export * from "./lotteryrecord.vue?vue&type=script&lang=js"
import style0 from "./lotteryrecord.vue?vue&type=style&index=0&id=06863b15&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports